import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-span-4 row-span-2 lg:col-span-2" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-full lg:col-span-1"
}
const _hoisted_3 = {
  key: 1,
  class: "block lg:hidden col-span-full lg:col-span-1"
}
const _hoisted_4 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_5 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_6 = { class: "hidden lg:block col-span-2 lg:col-span-1" }
const _hoisted_7 = {
  key: 2,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_8 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_9 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_10 = {
  key: 3,
  class: "col-span-2 lg:col-span-1"
}

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as userStore
	} from '@/store/user'

	import { // vue
		computed
	} from 'vue'

	
	const __default__ = { name: 'MeetingDetailsLocation' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		meeting: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	const _userStore = userStore()
	const {t} = useI18n()

	const addressDisplay = computed(() => {
		let address = []
		address.push(props.meeting?.fieldData?.building_name_to_display)
		address.push(props.meeting?.fieldData?.address_to_display)
		address.push(props.meeting?.fieldData?.city_to_display + " " + props.meeting?.fieldData?.state_to_display + " " + props.meeting?.fieldData?.postal_code_to_display)
		address.push(props.meeting?.fieldData?.country_to_display)

		let addressDisplay = address.filter(Boolean).join("\n")

		return addressDisplay
	})

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(_userStore).getContactType == 'Staff' ? 'grid grid-cols-6 gap-4 px-4 mt-3' : 'grid grid-cols-5 gap-4 px-4 mt-3'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('5'),
        "value-class": "whitespace-pre-line",
        value: addressDisplay.value || '-'
      }, null, 8, ["label", "value"])
    ]),
    (_unref(_userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_data_display, {
            label: _unref(store).getLabel('23'),
            value: __props.meeting?.fieldData?.['fc_calendar_sample_event__jobs__PLACES__placeID::name_display'] || '—'
          }, null, 8, ["label", "value"])
        ]))
      : _createCommentVNode("", true),
    (_unref(_userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_data_display, {
            label: _unref(store).getLabel('913'),
            value: __props.meeting?.fieldData?.['fc_calendar_sample_event__jobs__LOCATIONS__locationID::name_display'] || '—'
          }, null, 8, ["label", "value"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('361'),
        value: __props.meeting?.fieldData?.StartDate
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('1'),
        value: __props.meeting?.fieldData?.Type_display
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('913'),
        value: __props.meeting?.fieldData?.['fc_calendar_sample_event__jobs__LOCATIONS__locationID::name_display'] || '—'
      }, null, 8, ["label", "value"])
    ]),
    (_unref(_userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_data_display, {
            label: _unref(store).getLabel('196'),
            value: __props.meeting?.fieldData?.status_display
          }, null, 8, ["label", "value"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('144'),
        value: _ctx.$filters.hour24Time(__props.meeting?.fieldData?.StartTime) || '—'
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('322'),
        value: _ctx.$filters.hour24Time(__props.meeting?.fieldData?.EndTime) || '—'
      }, null, 8, ["label", "value"])
    ]),
    (_unref(_userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_data_display, {
            label: _unref(store).getLabel('405'),
            value: __props.meeting?.fieldData?.CompletetionTime || '—'
          }, null, 8, ["label", "value"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})